export const STANDARD_TEMPLATE = "standard"
export const COTTON_22_TEMPLATE = "cotton22"
export const LINEN_23_TEMPLATE = "linen23"
export const LINEN_25_TEMPLATE = "linen25"
export const SILK_24_TEMPLATE = "silk24"
export const DEFAULT_TEMPLATE = "default"
export const BACKSTITCH22_TEMPLATE = "backstitch22"
export const BASTINGSTITCH23_TEMPLATE = "bastingstitch23"
export const BLANKETSTITCH24_TEMPLATE = "blanketstitch24"
export const BLINDSTITCH25_TEMPLATE = "blindstitch25"
export const CASHMERE25_TEMPLATE = "cashmere25"
export const JERSEY25_TEMPLATE = "jersey25"
export const BUTTONHOLESTITCH25_TEMPLATE = "buttonholestitch25"
export const CHAINSTITCH25_TEMPLATE = "chainstitch25"
export const BASTINGSTITCH25_TEMPLATE = "bastingstitch25"
